<template>
  <div :class="{'high-level': isHighLevel}">
    <div class="top">
      <span class="tip warn" v-if="isHighLevel">
        提示：请前往 <app-link to="/cms-website/decoration">店铺装修</app-link> 配置轮播图
      </span>
      <span class="tip" v-else>小提示：您上传的轮播图优先于平台编辑的全局轮播图展示</span>
      <span class="top-after">
        <span>您还可添加{{ lessItems }}张</span>
        <zt-button
          type="primary"
          size="medium"
          class="add-button"
          width="96px"
          @click="onAddItemClick"
        >添加</zt-button>
      </span>
    </div>

    <div class="list" @click="handleOpenTip">
      <banner-card
        v-for="(o, i) of list"
        :key="o.id"
        v-bind.sync="o"
        :is-first="list[0].id === 0 ? i == 1 : i == 0"
        :is-last="i === list.length - 1"
        :index="i"
        role="taoke"
        @refresh="onRefreshList"
        @cancel="onCancel"
        @sort-up="onSortUpClick"
        @sort-down="onSortDownClick"
      />
    </div>
  </div>
</template>

<script>
import BannerCard from '@/views/cmsbanner/components/BannerCard';
import {
  taoke_cms_banner_recommend_list,
  taoke_cms_banner_recommend_order_set
} from '@/api/cmsbanner';
import { formatDate, diffStamp } from '@/utils/date';
export default {
  name: 'Swiper',
  components: {
    BannerCard,
  },
  data: () => ({
    list: [],
  }),

  computed: {
    lessItems: (vm) => 5 - vm.list.filter((o) => o.id).length,

    // cms版本
    vip: (vm) => vm.$store.state.user.info.vip - 0,

    // isTest: vm => ['www.com.nn', 'www.vv.com', 'www.3839.net', 'test.3839.net'].includes(vm.$store.state.cmsInfo.info.domain),

    // 是否为导购版以上
    isHighLevel: (vm) => [0, 1].includes(vm.vip) === false,
  },

  methods: {
    handleOpenTip() {
      if (this.isHighLevel) {
        this.$msgbox.confirm('请前往店铺装修配置轮播图', '提示').then(() => {
          this.$router.push('/cms-website/decoration')
        }).catch(() => {})
      }
    },

    defaultEndTime(time) {
      var _time = new Date(time);
      var _month = _time.getMonth();
      var _year = _time.getFullYear();
      var _day = _time.getDate();
      var _hours = _time.getHours();
      var _minutes = _time.getMinutes();
      var _seconds = _time.getSeconds();
      if (_month == 12) {
        _month = 1;
        _year++;
      } else {
        _month++;
      }
      return new Date(_year, _month, _day, _hours, _minutes, _seconds);
    },
    onAddItemClick() {
      const child = this.list[0];
      if (child && child.id == 0) return;

      this.list.unshift({ picture: '', url: '', id: 0, add_time: formatDate(new Date())});
    },
    onRefreshList() {
      this.loadList();
    },
    onCancel() {
      this.list.splice(0, 1);
    },

    // 排序按钮点击 上移动
    onSortUpClick({ index }) {
      // this.$refs.draggable.updatePosition(index, index - 1)
      this.updatePosition(index, index - 1);
      this.onSortChange();
    },
    onSortDownClick({ index }) {
      // this.$refs.draggable.updatePosition(index, index + 1)
      if (!this.list[index + 1].overdue) {
        this.updatePosition(index, index + 1);
        this.onSortChange();
      }
    },

    // 排序
    onSortChange() {
      // 没有id的元素永远只能放在第一位
      const newItem = this.list.find((o) => o.id == 0);
      if (this.list[0].id !== 0 && newItem) {
        const index = this.list.indexOf(newItem);
        this.sortItem(index, 0);
      }

      let sortId = this.list.map((o) => o.id);
      if (newItem) sortId.splice(0, 1);
      taoke_cms_banner_recommend_order_set(sortId.join(','));
    },

    updatePosition(oldIndex, newIndex) {
      this.list.splice(newIndex, 0, this.list.splice(oldIndex, 1)[0]);
    },
    fixList(list) {
      
      let overdueList =[]
      let oldList = list.concat()
      let newList =[]
      let overdueIndex = []
      for(let i=0;i<oldList.length;i++) {
        if(oldList[i].end_time!=undefined) {
          if(diffStamp(oldList[i].end_time)<0) {
            oldList[i].overdue = true
            oldList[i].overTime = Math.abs(diffStamp(oldList[i].end_time))
            overdueList.push(oldList[i])
            overdueIndex.push(oldList[i].id)
          }else{
            oldList[i].overdue = false
          }
        }
      }
      oldList.map((_newList) => {
        if(overdueIndex.indexOf(_newList.id)==-1) {
          newList.push(_newList)
        }
      })
      overdueList.sort(function(a, b) {
        return a.overTime-b.overTime
      })
      return newList.concat(overdueList)
    },
    async loadList() {
      const { data } = await taoke_cms_banner_recommend_list({
        type: 'CMS首页推荐',
      });
      if (!data.error_code) {
        this.list = data.list;
        this.list = this.fixList(this.list);
        if (data.list.length == 0) {
          this.onAddItemClick();
        }
      } else {
        // this.$message.error(data.error_message);
      }
    },
  },

  created() {
    this.loadList();
  },
};
</script>

<style lang="scss" scoped>
.top {
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;

  .top-after {
    display: inline-block;
    color: $theme-textsecond;
    span {
      margin-right: 10px;
    }
  }
}

.tip.warn {
  color: #FE7A42;
  .app-link {
    color: $theme;
    text-decoration: underline;
  }
}

.high-level /deep/ {
  .top-after {
    pointer-events: none;
  }
  .banner-card {
    pointer-events: none;
    opacity: .7;
  }
}
</style>